import React from "react";
import { useRouteError } from "react-router-dom";

import { PageError } from "../../components/Error";

import { ErrorResponse } from "../../api/services/defs/internal-api/internal-base-request";

import ErrorPage from "../Error/ErrorPage";

const REFUSED_STATUSES = new Set([403, 404]);

/**
 * Employee Details is single-tenant (PY-13817). The layout refuses up front when the URL names
 * another company, but a bare `/details/<id>/` names none, so the loader's employee preloads run
 * and reject — and a rejected loader renders the generic "Application Error" page. Turn the
 * refusal the API already made into the same intentional 403 the layout renders, and leave every
 * other failure to `PageError` so real outages still read as outages.
 */
export const EmployeeDetailsErrorPage: React.FC = () => {
	const routeError = useRouteError();
	const status = routeError instanceof ErrorResponse ? routeError.response?.status : undefined;

	if (status !== undefined && REFUSED_STATUSES.has(status)) {
		return <ErrorPage code={403} />;
	}

	return <PageError />;
};

export default EmployeeDetailsErrorPage;
